export enum CommentType {
  FollowOnNote = "FollowOnNote",
  PlannerNote = "PlannerNote",
  OperativeNote = "OperativeNote"
}
